import { HasFinancingEventInclusionMethod } from "@/generated/company-search";

/**
 * Keeps companies with (ANY_PRESENT) or without (NONE_PRESENT) a financing
 * event matching the conditions below. Unlike the Financing Events export
 * filters, it narrows the company set itself. Off while `inclusionMethod` is
 * null.
 */
export type FinancingEventsSlice = {
  inclusionMethod: HasFinancingEventInclusionMethod | null;
  /** Rolling window resolved by hermes when the query runs; null = any time. */
  discoveredWithinDays: number | null;
  financingTypes: string[];
  minAmount: number | null;
};

export const defaultFinancingEventsSlice: FinancingEventsSlice = {
  inclusionMethod: null,
  discoveredWithinDays: null,
  financingTypes: [],
  minAmount: null,
};
